"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EllipsisElement = void 0;
var dom_interact_1 = require("../helpers/dom-interact");
var DeviceManager_1 = require("./DeviceManager");
var EllipsisElement = /** @class */ (function () {
    function EllipsisElement(el, ellipsisGap) {
        this.el = el;
        this.deviceManager = new DeviceManager_1.DeviceManager();
        this.containerWidth = EllipsisElement.getContainerWidth(el);
        this.ellipsisGap = ellipsisGap;
        this.hiddenElementsCount = 0;
        this.manageEllipsis();
        this.attachEvents();
    }
    EllipsisElement.getContainerWidth = function (el) {
        // last child is hidden elements counter
        // so :nth-last-child(2) - is last child which can be hidden
        var lastEllipsisElement = el.querySelector(':nth-last-child(2)');
        // there are no applied filters and selected filters container width is 0
        if (!lastEllipsisElement) {
            return 0;
        }
        return lastEllipsisElement.getBoundingClientRect().right;
    };
    EllipsisElement.prototype.manageEllipsis = function () {
        if (this.deviceManager.getCurrentState() === DeviceManager_1.MOBILE) {
            return;
        }
        if (!this.shouldEllipsis()) {
            dom_interact_1.cssClass.remove(this.el, ['ellipsis-container']);
            return;
        }
        this.ellipsis();
    };
    EllipsisElement.prototype.updateRootElement = function (el) {
        this.el = el;
        this.containerWidth = EllipsisElement.getContainerWidth(el);
        this.manageEllipsis();
    };
    EllipsisElement.prototype.ellipsis = function () {
        var hiddenElementsCount = 0;
        var nodesListToEllipsis = (0, dom_interact_1.getHTMLElements)(this.el, '.js-ellipsis-item');
        var hiddenElementsHolder = (0, dom_interact_1.getHTMLElement)(this.el, '.js-ellipsis-hidden-items-holder');
        for (var i = nodesListToEllipsis.length; i > 0; i--) {
            var item = nodesListToEllipsis[i - 1];
            var itemRight = item.getBoundingClientRect().right;
            var hiddenElementsHolderLeft = hiddenElementsHolder.getBoundingClientRect().left;
            // if there is no hidden elements yet we need to check window width
            // otherwise left position of hidden elements count holder
            var pointToElipsis = this.hiddenElementsCount === 0
                ? document.body.clientWidth - this.ellipsisGap
                : hiddenElementsHolderLeft;
            if (itemRight < pointToElipsis) {
                dom_interact_1.cssClass.remove(item, ['js-ellipsis-item-hidden', 'ellipsis-item-hidden']);
            }
            else {
                dom_interact_1.cssClass.add(item, ['js-ellipsis-item-hidden', 'ellipsis-item-hidden']);
                hiddenElementsCount++;
                // once we have first hidden element we need to add this class to make hidden elements count holder visible
                dom_interact_1.cssClass.add(this.el, ['ellipsis-container']);
            }
        }
        if (hiddenElementsCount !== 0) {
            var hiddenElementsCountHolder = (0, dom_interact_1.getHTMLElement)(this.el, '.js-ellipsis-hidden-items-count');
            hiddenElementsCountHolder.innerHTML = String(hiddenElementsCount);
        }
        this.hiddenElementsCount = hiddenElementsCount;
    };
    EllipsisElement.prototype.shouldEllipsis = function () {
        return document.body.clientWidth - this.ellipsisGap < this.containerWidth;
    };
    EllipsisElement.prototype.attachEvents = function () {
        var _this = this;
        window.addEventListener('scroll', function () { return _this.manageEllipsis(); });
        window.addEventListener('resize', function () { return _this.manageEllipsis(); });
    };
    return EllipsisElement;
}());
exports.EllipsisElement = EllipsisElement;
